import { closeReconciliationURLs } from 'routes/close/closeURLs';

import { UserAvatar } from 'components/data-display/UserAvatar';

import { useUsersData } from 'hooks/useUsersData';

import { getName } from 'utils/users/config';

import { GenericNotificationItem } from 'layout/inbox-notifications/GenericNotificationItem';

import {
  ReconTaskStatusInPreparationNotification,
  ReconTaskStatusNotification,
  ReconTaskStatusReadyForReviewNotification,
} from 'types/inbox-notifications/close/ReconciliationNotifications';
import { SegmentAtByDot } from 'types/utils';

type StatusLevelKeys = SegmentAtByDot<ReconTaskStatusNotification['type'], 4>;

export function StatusNotificationItem({
  type,
  item,
}: {
  type: string[];
  item: ReconTaskStatusNotification;
}) {
  const [actionType, ..._restOfType] = type;
  if (!item.task) {
    return <div>Reconciliation task not found</div>;
  }

  switch (actionType as StatusLevelKeys) {
    case 'ready_for_review':
      return (
        <ReadyForReviewNotificationItem
          item={item as ReconTaskStatusReadyForReviewNotification}
        />
      );
    case 'in_preparation':
      return (
        <InPreparationNotificationItem
          item={item as ReconTaskStatusInPreparationNotification}
        />
      );
    default:
      return (
        <div>
          Unknown reconciliation task status notification type: {actionType}
        </div>
      );
  }
}

function ReadyForReviewNotificationItem({
  item,
}: {
  item: ReconTaskStatusReadyForReviewNotification;
}) {
  return (
    <GenericNotificationItem
      item={item}
      url={closeReconciliationURLs.taskBase({
        taskId: item.task.core_snapshot.short_code,
      })}
      avatar={<UserAvatar userId={item.actor_id} />}
      title="Your reconciliation is ready for review."
      description={<span>&quot;{item.task.core_snapshot.name}&quot;</span>}
    />
  );
}

function InPreparationNotificationItem({
  item,
}: {
  item: ReconTaskStatusInPreparationNotification;
}) {
  const { usersMap } = useUsersData();
  const actorName = getName(item.actor_id, usersMap);
  return (
    <GenericNotificationItem
      item={item}
      url={closeReconciliationURLs.taskBase({
        taskId: item.task.core_snapshot.short_code,
      })}
      avatar={<UserAvatar userId={item.actor_id} />}
      title={`${actorName} requested more preparation.`}
      description={<span>&quot;{item.task.core_snapshot.name}&quot;</span>}
    />
  );
}
